export default __webpack_public_path__ + "assets/tot-plus.0353b256.svg";